// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"1605":"strings-en","8276":"strings-fr"}[chunkId] || chunkId) + ".chunk.js";
};